import { gql } from 'apollo-boost';

const photoExamplesQuery = gql`
  query PhotoExamplesQuery {
    photoExamplesCollection {
      items {
        photo {
          url
          description
        }
      }
    }
  }
`;

export default photoExamplesQuery;